import { render, staticRenderFns } from "./h3-title.vue?vue&type=template&id=23d04d10&scoped=true&"
import script from "./h3-title.vue?vue&type=script&lang=js&"
export * from "./h3-title.vue?vue&type=script&lang=js&"
import style0 from "./h3-title.vue?vue&type=style&index=0&id=23d04d10&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d04d10",
  null
  
)

export default component.exports